import React, { useState } from "react";
import styles from "../../management/db-list/DBList.module.scss";
import modalStyles from "../../../common/management/Modal.module.scss";
import listStyles from "../../../common/management/ListWrapper.module.scss";
import ActionBtn from "../../../common/management/ActionBtn";
import Modal from "../../../common/management/Modal";
import { CategoryState } from "../../../utils/CategoryState";
import { RequestState } from "../../../utils/RequestState";
import Form from "../../../common/forms/Form";
import FormInput from "../../../common/forms/FormInput";
import GameSelectionItem from "./GameSelectionItem";
import { SonicGameSelectionItem } from "../../../common/classes/SonicGameSelection";
import ShuffleGameSelection from "./ShuffleGameSelection";

type Props = {
  id?: string;
  gameId: string;
  label: string;
  items: Array<SonicGameSelectionItem>;
  handleUpdate: (game_id: string, item: SonicGameSelectionItem) => void;
  field: string;
  handleDelete: (id: string, field: string, itemId: string) => void;
  handleShuffle: (
    id: string,
    field: string,
    shuffledIndex: Array<number>
  ) => void;
};
const GameSelectionItemList: React.FC<Props> = ({
  id,
  gameId,
  label,
  items,
  handleUpdate,
  field,
  handleDelete,
  handleShuffle,
}) => {
  const [categoryState, setCategoryState] = useState<CategoryState>(
    CategoryState.None
  );
  const [newValue, setNewValue] = useState<string>("");
  const [editItem, setEditItem] = useState<SonicGameSelectionItem>();
  const [deleteItem, setDeleteItem] = useState<SonicGameSelectionItem>();
  const [shuffledIndex, setShuffledIndex] = useState<Array<number>>([]);

  const headText = () => {
    switch (categoryState) {
      case CategoryState.Add:
        return `${label}を追加`;
      case CategoryState.Edit:
        return "選択肢を変更";
      case CategoryState.Sort:
        return "選択肢を並べ替える";
      case CategoryState.Delete:
        return `${label}の削除確認`;
      default:
        return "";
    }
  };

  const genModalBody = () => {
    switch (categoryState) {
      case CategoryState.Add:
        return (
          <>
            <Form
              handler={() => {}}
              className={modalStyles["f-modal__wrapper-content__form"]}
            >
              <FormInput
                type="text"
                label=""
                name="value"
                handler={(value) => {
                  if (value !== undefined && typeof value === "string") {
                    setNewValue(value);
                  }
                }}
                style_class={
                  modalStyles["f-modal__wrapper-content__form-input"]
                }
                placeholder={`${label}を入力`}
              />
            </Form>
          </>
        );
      case CategoryState.Edit:
        return (
          <>
            {`「${
              items.filter((item) => item.id === editItem?.id)[0]?.value
            }」を選択していたデータは全て「${
              editItem?.value
            }」に置き換わります。\n本当によろしいですか？`}
          </>
        );
      case CategoryState.Sort:
        return (
          <>
            <ShuffleGameSelection
              items={items}
              shuffledIndex={shuffledIndex}
              handleShuffle={(shuffledIndex: Array<number>) =>
                setShuffledIndex(shuffledIndex)
              }
            />
          </>
        );
      case CategoryState.Delete:
        return <>{`${label}名：「${deleteItem?.value}」を削除します。`}</>;
      default:
        return <></>;
    }
  };

  const genButtonText = () => {
    switch (categoryState) {
      case CategoryState.Add:
        return "追加";
      case CategoryState.Edit:
      case CategoryState.Sort:
        return "確定";
      case CategoryState.Delete:
        return "削除";
      default:
        return "";
    }
  };

  const createHandler = () => {
    if (newValue) {
      handleUpdate(gameId, { id: "", value: newValue });
    }
  };

  const editHandler = () => {
    if (editItem) {
      handleUpdate(gameId, editItem);
    }
  };

  const deleteHandler = () => {
    if (id && deleteItem) {
      handleDelete(id, field, deleteItem.id);
    }
  };

  const shuffleHandler = () => {
    if (id && shuffledIndex.length) {
      handleShuffle(id, field, shuffledIndex);
    }
  };

  return (
    <>
      <div className={listStyles["f-listWrapper__content-list__btn-area"]}>
        <ActionBtn
          label="新規追加"
          type="button"
          icon={["fal", "plus-circle"]}
          onClick={() => setCategoryState(CategoryState.Add)}
        />
        {items.length >= 2 ? (
          <ActionBtn
            label="並べ替え"
            type="button"
            icon={["fal", "arrow-up-arrow-down"]}
            onClick={() => setCategoryState(CategoryState.Sort)}
          />
        ) : null}
      </div>

      <div className={styles["f-dbList"]}>
        <div
          className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["game-selection"]}`}
        >
          <div>{label}</div>
          <div>編集</div>
        </div>

        {id
          ? items.map((item) => (
              <GameSelectionItem
                key={item.id}
                item={item}
                setEditItem={(item: SonicGameSelectionItem) => {
                  setEditItem(item);
                  setCategoryState(CategoryState.Edit);
                }}
                setDeleteItem={(item: SonicGameSelectionItem) => {
                  setDeleteItem(item);
                  setCategoryState(CategoryState.Delete);
                }}
              />
            ))
          : null}
      </div>

      {categoryState !== CategoryState.None ? (
        <Modal
          closeModal={() => {
            setCategoryState(CategoryState.None);
          }}
          handler={
            categoryState === CategoryState.Add
              ? createHandler
              : categoryState === CategoryState.Edit
              ? editHandler
              : categoryState === CategoryState.Sort
              ? shuffleHandler
              : categoryState === CategoryState.Delete
              ? deleteHandler
              : () => {}
          }
          categoryState={categoryState}
          requestState={RequestState.Waiting}
          headText={headText()}
          buttonText={genButtonText()}
          error={""}
        >
          {genModalBody()}
        </Modal>
      ) : null}
    </>
  );
};

export default GameSelectionItemList;
